"use strict";
/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const theme_1 = require("../../theme");
const services_1 = require("../support/services");
/**
 * The `TopNavigationAction` component is a part of the `TopNavigation` component.
 * `TopNavigationActions` should be used in `TopNavigation` to provide usable component.
 * See usage examples at `TopNavigation` component documentation.
 *
 * @extends React.Component
 *
 * @property {(style: ImageStyle) => ReactElement} icon - Determines the icon of the component.
 *
 * @property {TouchableOpacityProps} ...TouchableOpacityProps - Any props applied to TouchableOpacity component.
 *
 * @overview-example TopNavigationActionSimpleUsage
 *
 * @example TopNavigationActionExternalSourceIcon
 *
 * @example TopNavigationActionInlineStyling
 */
class TopNavigationActionComponent extends react_1.default.Component {
    constructor() {
        super(...arguments);
        this.webEventResponder = services_1.WebEventResponder.create(this);
        this.onMouseEnter = () => {
            this.props.dispatch([theme_1.Interaction.HOVER]);
        };
        this.onMouseLeave = () => {
            this.props.dispatch([]);
        };
        this.onFocus = () => {
            this.props.dispatch([theme_1.Interaction.FOCUSED]);
        };
        this.onBlur = () => {
            this.props.dispatch([]);
        };
        this.onPress = (event) => {
            if (this.props.onPress) {
                this.props.onPress(event);
            }
        };
        this.onPressIn = (event) => {
            this.props.dispatch([theme_1.Interaction.ACTIVE]);
            if (this.props.onPressIn) {
                this.props.onPressIn(event);
            }
        };
        this.onPressOut = (event) => {
            this.props.dispatch([]);
            if (this.props.onPressOut) {
                this.props.onPressOut(event);
            }
        };
        this.getComponentStyle = (source) => {
            const { iconTintColor, iconWidth, iconHeight, iconMarginHorizontal, } = source;
            return {
                container: {
                    marginHorizontal: iconMarginHorizontal,
                },
                icon: {
                    tintColor: iconTintColor,
                    width: iconWidth,
                    height: iconHeight,
                    ...styles.icon,
                },
            };
        };
        this.createHitSlopInsets = (iconStyle) => {
            const flatStyle = react_native_1.StyleSheet.flatten(iconStyle);
            // @ts-ignore: `width` is restricted to be a number
            const value = 40 - flatStyle.width;
            return {
                left: value,
                top: value,
                right: value,
                bottom: value,
            };
        };
        this.renderIconElement = (style) => {
            const iconElement = this.props.icon(style);
            return react_1.default.cloneElement(iconElement, {
                style: [style, iconElement.props.style],
            });
        };
    }
    render() {
        const { themedStyle, style, icon, ...touchableProps } = this.props;
        const componentStyle = this.getComponentStyle(themedStyle);
        const hitSlopInsets = this.createHitSlopInsets(componentStyle.icon);
        const iconElement = this.renderIconElement(componentStyle.icon);
        return (react_1.default.createElement(react_native_1.TouchableOpacity, Object.assign({ activeOpacity: 1.0, hitSlop: hitSlopInsets }, touchableProps, this.webEventResponder.eventHandlers, { style: [componentStyle.container, styles.container, webStyles.container, style], onPress: this.onPress, onPressIn: this.onPressIn, onPressOut: this.onPressOut }), iconElement));
    }
}
TopNavigationActionComponent.styledComponentName = 'TopNavigationAction';
const styles = react_native_1.StyleSheet.create({
    container: {},
    icon: {},
});
const webStyles = react_native_1.Platform.OS === 'web' && react_native_1.StyleSheet.create({
    container: {
        // @ts-ignore
        outlineWidth: 0,
    },
});
exports.TopNavigationAction = theme_1.styled(TopNavigationActionComponent);
//# sourceMappingURL=topNavigationAction.component.js.map